import React, { useState, useEffect, useCallback } from 'react';
import { Box, Button, CircularProgress } from '@mui/material';
import { getAuth } from 'firebase/auth';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { db } from '../../../firebase';
import UserForm from '../UserForm';
import { logAnalyticsEvent } from '../../../utils/analytics';

const BasicInfoSection = ({ onSave, initialData }) => {
  const [formData, setFormData] = useState(initialData);
  const [isSaving, setIsSaving] = useState(false);
  const [error, setError] = useState('');
  const [progress, setProgress] = useState(0);

  const calculateProgress = useCallback(() => {
    const requiredFields = ['firstName', 'lastName', 'dateOfBirth', 'gender'];
    const optionalFields = ['dietPreference']; // Diet preference is optional but adds to completeness
    
    const filledRequiredFields = requiredFields.filter(field => !!formData[field]);
    const filledOptionalFields = optionalFields.filter(field => !!formData[field]);
    
    // Base progress from required fields (80% weight)
    const baseProgress = (filledRequiredFields.length / requiredFields.length) * 80;
    
    // Bonus progress from optional fields (20% weight)
    const bonusProgress = (filledOptionalFields.length / optionalFields.length) * 20;
    
    return baseProgress + bonusProgress;
  }, [formData]);

  useEffect(() => {
    setFormData(initialData);
    setProgress(calculateProgress());
  }, [initialData, calculateProgress]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    
    // Prevent email changes - email should only be changed through Security section
    if (name === 'email') {
      return;
    }
    
    setFormData(prev => {
      const newFormData = { ...prev, [name]: value };
      console.log('🔄 [BasicInfoSection] Form data changed:', { name, value, newFormData });
      // Pass the updated form data immediately to the parent
      onSave(newFormData);
      return newFormData;
    });
  };

  // This component reuses the existing UserForm, so no separate save logic is needed here
  // The parent ProfilePageRedesign will handle the master save.

  return (
    <Box>
      <UserForm formData={formData} handleChange={handleChange} isDisabled={isSaving} showEmail={false} showDietPreference={true} />
    </Box>
  );
};

export default BasicInfoSection; 